export function unwrapEntity<T>(response: unknown): T {
  const r = response as { data?: T; success?: boolean } | T;
  if (
    r &&
    typeof r === "object" &&
    "data" in (r as object) &&
    (r as { data?: T }).data != null &&
    (r as { success?: boolean }).success !== false
  ) {
    return (r as { data: T }).data;
  }
  return response as T;
}

export function unwrapOrThrow<T>(response: unknown, fallbackMessage: string): T {
  const r = response as {
    data?: T;
    success?: boolean;
    message?: string;
  } | null;
  if (r && typeof r === "object" && "success" in r && r.success === false) {
    throw new Error(r.message || fallbackMessage);
  }
  return unwrapEntity<T>(response);
}
